import React from "react";

interface LandingPageCardProps {
  icon: string;
  title: string;
  description: string;
  showBorder?: boolean
}

export const LandingPageCard: React.FC<LandingPageCardProps> = ({ icon, title, description, showBorder }) => {
  return (
      <div className="lg:w-[400px] w-full relative pl-7 pr-7">
        <img src={icon} alt={title} className="w-[52px] h-[52px]" />
        <div className="text-start">
          <p className="text-[20px] mt-3 font-semibold">{title}</p>
          <p className="text-[#232323] text-[16px] mt-2  font-light">{description}</p>
        </div>
        {showBorder && <div className="lg:absolute mx-auto mt-[30px] lg:mt-0 right-0 bottom-[-30px] lg:right-[-20px] lg:top-32 border-gray-300 border border-l-0 border-t-0 border-b-2 border-r-0 lg:border-r-2 lg:border-b-0 lg:h-24 w-[150px] lg:w-0"></div>}
      </div>
  );
};

